import { useTranslation } from "react-i18next";

// 骨架屏组件
export const SubscriptionSettingsSkeleton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex space-x-4 pb-6 border-b border-[rgba(233,234,235,1)]'>
      {/* 时间选择器骨架屏 */}
      <div>
        <label className='text-sm font-medium text-[rgba(52,64,84,1)] mb-3 inline-block'>{t('agent_dashboard.subscription_settings.time')}</label>
        <div className='w-[22.13rem] h-11 bg-gray-200 rounded animate-pulse flex items-center px-3'>
        </div>
      </div>

      {/* 频率输入骨架屏 */}
      <div className='w-[22.13rem]'>
        <label className='text-sm font-medium text-[rgba(52,64,84,1)] mb-3 inline-block'>
          {t('agent_dashboard.subscription_settings.frequency')}
          <span className='text-[rgba(117,66,247,1)]'>*</span>
        </label>
        <div className='relative flex items-center'>
          <div className='w-[10rem] h-11 bg-gray-200 rounded animate-pulse'></div>
        </div>
      </div>

      {/* 类型输入骨架屏 */}
      <div>
        <label className='text-sm font-medium text-[rgba(52,64,84,1)] mb-3 inline-block'>{t('agent_dashboard.subscription_settings.type')}</label>
        <div className='w-[22.13rem] h-11 bg-gray-200 rounded animate-pulse'></div>
      </div>
    </div>
  );
};